import { lazy } from 'react';
import retry from '../../utils/webpack/chunkRetry';

const ModuleLoaderLazy = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "gifting", webpackPrefetch: true */
        './ModuleLoader'
      )
  )
);

export default ModuleLoaderLazy;
